import { createContext, useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";

import { userContext } from "./userContext";
import { readDarkModeSetting, saveDarkModeSetting } from "src/data/person/darkModeFunctions";

export const DarkModeContext = createContext();

export const DarkModeProvider = ({ children }) => {
  const { user, token, doSetUser } = useContext(userContext) || {};
  const [darkMode, setDarkMode] = useState(readDarkModeSetting());
  const [isExtendedView, setIsExtendedView] = useState(false);

  useEffect(() => {
    if (!user || !token) return;
    if (user.isExtendedView == isExtendedView) return;
    setIsExtendedView(user.isExtendedView);
  }, [user, token]);

  useEffect(() => {
    if (!user || !token) return;
    if (user.darkMode == darkMode) return;
    saveDarkModeSetting(user.darkMode, user.personId, token);
    setDarkMode(user.darkMode);
  }, [user, token]);

  const doSetDarkMode = async (darkMode) => {
    setDarkMode(darkMode);
    if (!user) return;
    await saveDarkModeSetting(darkMode, user?.personId, token); // no need to wait for this
    user.darkMode = darkMode;
    doSetUser(user);
  };

  const doSetExtendedView = async (isExtendedView) => {
    setIsExtendedView(isExtendedView);
    if (!user) return;
    user.isExtendedView = isExtendedView;
    doSetUser(user);
  };

  const toggleDarkMode = async () => doSetDarkMode(!darkMode);

  return (
    <DarkModeContext.Provider
      value={{
        darkMode,
        doSetDarkMode,
        toggleDarkMode,
        isExtendedView,
        setIsExtendedView: doSetExtendedView,
      }}>
      {children}
    </DarkModeContext.Provider>
  );
};

export const useDarkModeData = () => useContext(DarkModeContext);

DarkModeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
